
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Stack, Button, Popover, Container, Typography ,IconButton,Icon, TextField, Tooltip} from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { useTheme } from '@material-ui/core/styles';
import { Block } from '../components-overview/Block';
import Label from 'src/components/Label';
import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { formatDateOnly, dateOnlyMoment, dateOnlyToUnix } from 'src/utils/dateOnly';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useSnackbar } from 'notistack';
import { LoadingButton, LocalizationProvider, MobileDatePicker, MobileDateRangePicker } from '@material-ui/lab';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import axios from 'axios';
import ProductsPopover from '../../components/ProductsPopover';
import ServicesPopover from '../../components/ServicesPopover';
import { usesEstimateSingleDateOnly } from './EstimateCalendar';
const style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
  const option = [
  { id: 0, value: 'Inactive' },
  { id: 1, value: 'New' },
  { id: 2, value: 'Open' },
  { id: 3, value: 'Completed' },
  { id: 4, value: 'In Testing' },
  { id: 5, value: 'Accepted' },
  { id: 6, value: 'Rejected' },
  { id: 7, value: 'Verified' },
  { id: 6, value: 'Reopen' },
]
const colors = [
  'error',
  'primary',
  'secondary',
  'success',
  'warning',
  'success',
  'error',
  'success',
  'error',
]
export default function EstimateCalendarPopOver({ title, open, handleClose, project, anchorOrigin, setRefresh, refresh, setOpen, embeddedInPcb = false }){
  console.log('project--EstimateCalendarPopOver--',project)
    const theme = useTheme();
    const navigate = useNavigate()
    const user  = JSON.parse(window.localStorage.getItem('user'))
    const explodedPermissions =user?.exploded_permissions
    const { enqueueSnackbar } = useSnackbar();
    const [productsPopoverOpen, setProductsPopoverOpen] = useState(false);
    const [productsPopoverAnchor, setProductsPopoverAnchor] = useState(null);
    const [servicesPopoverOpen, setServicesPopoverOpen] = useState(false);
    const [servicesPopoverAnchor, setServicesPopoverAnchor] = useState(null);
      const [installDate, setInstallDate] = useState(
    project ? moment(project.start).format("YYYY-MM-DD") : ""
  );
  const [installStartDate, setInstallStartDate] = useState(null);
  const [installEndDate, setInstallEndDate] = useState(null);
  const [requestedDueDate, setRequestedDueDate] = useState('');
  const [isUpdating,setUpdating] = useState(false)

  const singleDateOnly = usesEstimateSingleDateOnly(project?.calendar_stage);
  const isRejectedEstimate =
    project?.calendar_stage === 'Rejected' ||
    Number(project?.is_rejected) === 1 ||
    Number(project?.quotation_status) === 6;

  useEffect(() => {
    if (project) {
      if (project.installation_end_date) {
        setInstallDate(formatDateOnly(project.installation_end_date, 'YYYY-MM-DD'));
      } else if (project.participation_ends) {
        setInstallDate(formatDateOnly(project.participation_ends, 'YYYY-MM-DD'));
      } else if (project.start) {
        setInstallDate(formatDateOnly(project.start, 'YYYY-MM-DD'));
      }
      setInstallStartDate(
        project.installation_start_date ? dateOnlyMoment(project.installation_start_date).toDate() : null
      );
      setInstallEndDate(
        project.installation_end_date ? dateOnlyMoment(project.installation_end_date).toDate() : null
      );
    }
  }, [project]);

  const orderStartMin =
    project?.start_date && moment(project.start_date).isValid()
      ? moment(project.start_date).toDate()
      : undefined;

  const installEndMinDate = (() => {
    const orderStart = orderStartMin ? moment(orderStartMin) : null;
    const rangeStart = installStartDate ? moment(installStartDate) : null;
    if (rangeStart && orderStart) return moment.max(rangeStart, orderStart).toDate();
    if (rangeStart) return rangeStart.toDate();
    if (orderStart) return orderStart.toDate();
    return new Date();
  })();

  const handleUpdateEstimateDate = async () => {
    try {
      setUpdating(true);
      if (!explodedPermissions?.some((permission) => ['Manage Estimate Calendar'].includes(permission))) {
        return enqueueSnackbar("You don't have necessary permission", { variant: 'error' });
      }

      const payload = {
        request_id: project.id,
        added_by: user.user_id,
      };

      if (singleDateOnly) {
        payload.participation_ends = dateOnlyToUnix(installDate);
        payload.installation_start_date = null;
        payload.installation_end_date = null;
      } else if (installStartDate && installEndDate) {
        payload.installation_start_date = dateOnlyToUnix(installStartDate);
        payload.installation_end_date = dateOnlyToUnix(installEndDate);
        payload.participation_ends = dateOnlyToUnix(installEndDate);
      } else if (installDate) {
        payload.participation_ends = dateOnlyToUnix(installDate);
        payload.installation_start_date = null;
        payload.installation_end_date = null;
      }

      const response = await axios.post(`${REST_API_END_POINT}request/update-estimate-calendar-date`, payload);
      if (response.data.status === 1) {
        enqueueSnackbar('Estimate date updated successfully', { variant: 'success' });
        setOpen(false);
        setRefresh(!refresh);
      } else {
        setOpen(false);
        enqueueSnackbar(response.data.message || 'Failed to update estimate date', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Failed to update estimate date', { variant: 'error' });
    } finally {
      setUpdating(false);
    }
  };

  return(
        <Popover 
        open={open}       
         onClose={handleClose}
        anchorOrigin={{
          vertical: anchorOrigin.top,
          horizontal: anchorOrigin.left
        }}

      >
       <Box sx={{ p: 2, maxWidth: 280 }}>
    <Stack sx={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
      <Typography variant='subtitle1' gutterBottom>Estimate Details</Typography>
      <IconButton
        onClick={handleClose}
        sx={{ position: 'relative', top: -5, right: 5, }}
      >
        <Close sx={{width:15,height:15}} />
      </IconButton>
    </Stack>
    <Typography variant="body2" sx={{ color: 'text.secondary', display: 'inline-flex', alignItems: 'center' }}>
      Estimate Name: <Stack sx={{ color: theme.palette.primary.main, marginLeft: 1,cursor:'pointer' }} 
      onClick={() => {
        if (user.user_type !== 3) {
          if (explodedPermissions?.some((permission) =>
            ['View Estimate', 'Edit Estimate', 'View Estimate as Admin', 'View Estimate Jobs'].includes(permission)
          )) {
            navigate(PATH_DASHBOARD.quotation.viewRequest.replace(':id', project.id), {
              state: { fromEstimateCalendar: true, ...(embeddedInPcb && { fromPcb: true }) },
            });
          } else {
            enqueueSnackbar('Access Denied: You do not have permission to view estimate', { variant: 'error' });
          }
        }
      }}>{project && project.title}</Stack>
    </Typography>
    <Box display="flex" alignItems="center">
      <Typography variant="body2" color="text.secondary">Start Date:</Typography>
      <Typography variant="body2" sx={{ color: theme.palette.primary.main, ml: 1 }}>
        {project && formatDateOnly(project.start_date)}
      </Typography>
    </Box>
    <Box display="flex" alignItems="center">
      <Typography variant="body2" color="text.secondary">QB Number:</Typography>
      <Typography variant="body2" sx={{ color: theme.palette.primary.main, ml: 1 }}>
        {project?.doc_number ? `#${project?.doc_number}` : ''}
      </Typography>
    </Box>
    <Typography
      variant="body2"
      sx={{ color: 'text.secondary', display: 'flex', alignItems: 'center', mb: 0.5 }}
    >
      Client Name:{' '}
      <Tooltip title={project?.customer_name || ''}>
        <Typography
          sx={{
            color: theme.palette.primary.main,
            marginLeft: 1,
            maxWidth: 150,     
            fontSize: '0.95rem',   
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {project?.customer_name}
        </Typography>
      </Tooltip>
    </Typography>
    <Typography
      variant="body2"
      sx={{ color: 'text.secondary', display: 'flex', alignItems: 'center' }}
    >
      Project:{' '}
      <Tooltip title={project?.community_name || ''}>
        <Typography
          sx={{
            color: theme.palette.primary.main,
            marginLeft: 1,
            maxWidth: 150,  
            fontSize: '0.95rem',       
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {project?.community_name}
        </Typography>
      </Tooltip>
    </Typography>
    {project?.product_name ? (
      <Box>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.5 }}>
          Product{project?.product_name?.includes(',') ? 's' : ''}:
        </Typography>
        {(() => {
          const products = project?.product_name ? project.product_name.split(',').map(p => p.trim()).filter(p => p) : [];
          const eventColor = theme.palette.primary.main;
          
          if (products.length <= 2) {
            return (
              <Box
                sx={{
                  backgroundColor: `${eventColor}15`,
                  border: `1px solid ${eventColor}40`,
                  borderRadius: '4px',
                  padding: '6px 8px',
                  minHeight: '30px'
                }}
              >
                <Stack spacing={0.5}>
                  {products.map((product, index) => (
                    <Typography
                      key={index}
                      color={eventColor}
                      fontSize="0.7rem"
                      sx={{
                        lineHeight: 1.2,
                        opacity: 0.9,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block'
                      }}
                      variant="caption"
                    >
                      • {product}
                    </Typography>
                  ))}
                </Stack>
              </Box>
            );
          }
          
          // Show first 2 products + count more
          const firstTwoProducts = products.slice(0, 2);
          const remainingCount = products.length - 2;
          
          return (
            <Box
              sx={{
                backgroundColor: `${eventColor}15`,
                border: `1px solid ${eventColor}40`,
                borderRadius: '4px',
                padding: '6px 8px',
                minHeight: '30px',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: `${eventColor}25`,
                  border: `1px solid ${eventColor}60`
                }
              }}
            >
              <Stack spacing={0.5}>
                {firstTwoProducts.map((product, index) => (
                  <Typography
                    key={index}
                    color={eventColor}
                    fontSize="0.7rem"
                    sx={{
                      lineHeight: 1.2,
                      opacity: 0.9,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      display: 'block'
                    }}
                    variant="caption"
                  >
                    • {product}
                  </Typography>
                ))}
                <Typography
                  color={eventColor}
                  fontSize="0.7rem"
                  sx={{
                    lineHeight: 1.2,
                    opacity: 0.9,
                    fontWeight: 600,
                    display: 'block',
                    cursor: 'pointer',
                    '&:hover': {
                      opacity: 1,
                      textDecoration: 'underline'
                    }
                  }}
                  variant="caption"
                  onClick={(e) => {
                    e.stopPropagation();
                    setProductsPopoverAnchor(e.currentTarget);
                    setProductsPopoverOpen(true);
                  }}
                >
                  +{remainingCount} more
                </Typography>
              </Stack>
            </Box>
          );
        })()}
        <ProductsPopover
          productNames={project?.product_name}
          open={productsPopoverOpen}
          anchorEl={productsPopoverAnchor}
          onClose={() => setProductsPopoverOpen(false)}
          eventColor={theme.palette.primary.main}
        />
      </Box>
    ) : ''}
    {project?.service_name ? (
      <Box>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.5 }}>
          Service{project?.service_name?.includes(',') ? 's' : ''}:
        </Typography>
        {(() => {
          const services = project?.service_name ? project.service_name.split(',').map(s => s.trim()).filter(s => s) : [];
          const eventColor = theme.palette.primary.main;
          
          if (services.length <= 2) {
            return (
              <Box
                sx={{
                  backgroundColor: `${eventColor}15`,
                  border: `1px solid ${eventColor}40`,
                  borderRadius: '4px',
                  padding: '6px 8px',
                  minHeight: '30px'
                }}
              >
                <Stack spacing={0.5}>
                  {services.map((service, index) => (
                    <Typography
                      key={index}
                      color={eventColor}
                      fontSize="0.7rem"
                      sx={{
                        lineHeight: 1.2,
                        opacity: 0.9,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block'
                      }}
                      variant="caption"
                    >
                      • {service}
                    </Typography>
                  ))}
                </Stack>
              </Box>
            );
          }
          
          // Show first 2 services + count more
          const firstTwoServices = services.slice(0, 2);
          const remainingCount = services.length - 2;
          
          return (
            <Box
              sx={{
                backgroundColor: `${eventColor}15`,
                border: `1px solid ${eventColor}40`,
                borderRadius: '4px',
                padding: '6px 8px',
                minHeight: '30px',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: `${eventColor}25`,
                  border: `1px solid ${eventColor}60`
                }
              }}
            >
              <Stack spacing={0.5}>
                {firstTwoServices.map((service, index) => (
                  <Typography
                    key={index}
                    color={eventColor}
                    fontSize="0.7rem"
                    sx={{
                      lineHeight: 1.2,
                      opacity: 0.9,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      display: 'block'
                    }}
                    variant="caption"
                  >
                    • {service}
                  </Typography>
                ))}
                <Typography
                  color={eventColor}
                  fontSize="0.7rem"
                  sx={{
                    lineHeight: 1.2,
                    opacity: 0.9,
                    fontWeight: 600,
                    display: 'block',
                    cursor: 'pointer',
                    '&:hover': {
                      opacity: 1,
                      textDecoration: 'underline'
                    }
                  }}
                  variant="caption"
                  onClick={(e) => {
                    e.stopPropagation();
                    setServicesPopoverAnchor(e.currentTarget);
                    setServicesPopoverOpen(true);
                  }}
                >
                  +{remainingCount} more
                </Typography>
              </Stack>
            </Box>
          );
        })()}
        <ServicesPopover
          serviceNames={project?.service_name}
          open={servicesPopoverOpen}
          anchorEl={servicesPopoverAnchor}
          onClose={() => setServicesPopoverOpen(false)}
          eventColor={theme.palette.primary.main}
        />
      </Box>
    ) : ''}
    {/* {project?.design_order == true ?
    <Typography variant="body2" sx={{ color: 'text.secondary', display: 'inline-flex', alignItems: 'center' }}>
      Due Date: <Stack sx={{ color: theme.palette.primary.main, marginLeft: 1 }}>{project &&moment(project.start).format("MM/DD/YYYY")}</Stack>
    </Typography>
    : */}
    {!isRejectedEstimate ? (
      <Box sx={{ mt: 2 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
          {singleDateOnly ? 'Estimate Date:' : 'Installation Date:'}
        </Typography>
        {!singleDateOnly ? (
          <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
            Choose either single installation date OR installation date range
          </Typography>
        ) : (
          <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
            Select the estimate scheduled date
          </Typography>
        )}

        <Stack spacing={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDatePicker
              orientation="portrait"
              label={singleDateOnly ? 'Estimate Date' : 'Installation Date'}
              minDate={orderStartMin}
            value={installDate ? new Date(installDate) : null}
              onChange={(newValue) => {
                if (newValue) {
                  setInstallDate(moment(newValue).format('YYYY-MM-DD'));
                  setInstallStartDate(null);
                  setInstallEndDate(null);
                }
              }}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  size="small"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      '& input': {
                        color: theme.palette.primary.main,
                        fontSize: '0.875rem'
                      }
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </LocalizationProvider>

          {!singleDateOnly ? (
            <Stack direction="row" spacing={1}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  orientation="portrait"
                  label="Installation Start Date"
                  minDate={orderStartMin}
                value={installStartDate}
                  onChange={(newValue) => {
                    if (newValue) {
                      setInstallStartDate(newValue);
                      setInstallDate('');
                      if (installEndDate && moment(newValue).isAfter(moment(installEndDate))) {
                        setInstallEndDate(null);
                      }
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      sx={{ flex: 1 }}
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          '& input': {
                            color: theme.palette.primary.main,
                            fontSize: '0.875rem'
                          }
                        }
                      }}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  orientation="portrait"
                  label="Installation End Date"
                  value={installEndDate}
                  minDate={installEndMinDate}
                  onChange={(newValue) => {
                    if (newValue) {
                      setInstallEndDate(newValue);
                      setInstallDate(moment(newValue).format('YYYY-MM-DD'));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      sx={{ flex: 1 }}
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          '& input': {
                            color: theme.palette.primary.main,
                            fontSize: '0.875rem'
                          }
                        }
                      }}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Stack>
          ) : ''}

          <Stack direction="row" spacing={1} sx={{ justifyContent: 'flex-start' }}>
            <LoadingButton 
              onClick={handleUpdateEstimateDate} 
              loading={isUpdating} 
              variant='contained' 
              size="small"
              disabled={singleDateOnly ? !installDate : (!installDate && !(installStartDate && installEndDate))}
            >
              Save
            </LoadingButton>
            <Button 
              onClick={handleClose} 
              variant='outlined' 
              size="small"
            >
              Cancel
            </Button>
          </Stack>
        </Stack>
      </Box>
    ) : null}
    {/* } */}

    <Stack direction="row" spacing={1}>
  {/* <Typography variant='subtitle1'> Status : {' '} 
    <Label
      variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
      color={colors[project?.status]}
    >
      {project && project.status !== undefined
        ? option.find(opt => opt.id === project.status)?.value
        : 'Unknown Status'}
    </Label>
  </Typography> */}
</Stack>

  </Box>
      </Popover>   
    )
}